// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Adjust as needed */
  width: 100%;
}

/* Header */
.dp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2%;
  text-align: left;
  font-weight: bold;
}

.add-dp {
  display: flex;
  width: 16%;
  background-color: #79c42b;
  text-align: center;
  color: #fff;
  gap: 1%;
  font-size: medium;
  border-radius: 5px;
  height: 60%;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.add-dp:hover {
  background-color: #68a822; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.add-dp:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.add-dp:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.add-new {
  padding: 2% 0 0 0;
  text-align: center;
  margin-bottom: 10%;
  border-radius: 8px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, background-color 0.3s ease,
    box-shadow 0.3s ease;
  color: #949494;
  background-color: #f2f2f2;
  border: 2px dashed #000;
  cursor: pointer;
}

.add-new:hover {
  background-color: #e0e0e0; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.add-new:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.add-new:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.add-dp span {
  display: flex;
  margin: 6%;
}

.add-icon {
  font-size: xx-large;
}

/* Department List */
.department-section {
  margin-bottom: 5%;
}

.department-list {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(4, minmax(20%, 1fr));
  gap: 2%;
  padding: 2%;
}

.department-card {
  display: flex;
  background: #00a1da;
  color: #fff;
  padding: 5%;
  margin-bottom: 10%;
  border-radius: 8px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
}

.department-card:hover {
  transform: scale(1.05);
}

.department-icon {
  width: 32px;
  height: 32px;
  margin: 4% 0 0 5%;
}

.dp-name {
  font-size: x-large;
  text-align: center;
  margin: 5%;
}

.dp-icon {
  font-size: x-large;
}

.add-new:hover {
  background-color: #e0e0e0;
}

.addDp-name {
  font-size: x-large;
}

/* 🔹 Pop-up Overlay */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* 🔹 Pop-up Content */
.popup-content {
  background: #e8e9ea;
  width: 30%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  background-color: #00468c;
  color: #fff;
  padding: 1% 4%;
  text-align: left;
  align-items: center;
}

.dp-form {
  padding: 5%;
}

/* 🔹 Close Button */
.close-popup {
  background: none;
  border: none;
  font-size: x-large;
  cursor: pointer;
}

.custom-file-button {
  position: absolute;
  right: 2%; /* Adjusted to the right */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: #79c42b;
  color: white;
  padding: 2% 3% 0 3%;
  border-radius: 5px;
  font-size: small;
  font-weight: bold;
  border: none;
  height: 50%;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.custom-file-button:hover {
  background-color: #68a822; /* slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.custom-file-button:active {
  transform: translateY(-50%) scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.custom-file-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

/* 🔹 Add Button */
.add-button {
  background: #79c42b;
  color: white;
  padding: 2% 4%;
  border: 1px solid #79c42b;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 10%;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.add-button:hover {
  background: #68a822; /* slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.add-button:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.add-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

/* DP Cancel Button */
.dp-cancel {
  color: #000;
  padding: 2% 4%;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #79c42b;
  background-color: #fff;
  margin-left: 50%;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.dp-cancel:hover {
  background-color: #f2f2f2;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.dp-cancel:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.dp-cancel:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.file-upload {
  margin-bottom: 10%;
}

.file-input-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 2%;
}

.file-name-input {
  width: 100%;
  height: 30px;
  padding: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: medium;
  background-color: #f8f9fa;
  padding-right: 100px; /* Space for the button */
}

.input-group {
  gap: 2%;
  width: 100%;
  margin-bottom: 5%;
}

.ad-label {
  display: flex;
  text-align: left;
  margin: 2%;
}

.name-input {
  width: 95%;
  padding: 2%;
}

.size {
  font-style: italic;
  color: blue;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddDepartment/AddDepartment.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,qBAAqB;EACpC,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C;wBACsB;EACtB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,0BAA0B;EACrC,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;wBACsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,oBAAoB;EACzC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB;wBACsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB,EAAE,yBAAyB;AACjD;;AAEA;EACE,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".department-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Adjust as needed */\n  width: 100%;\n}\n\n/* Header */\n.dp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2%;\n  text-align: left;\n  font-weight: bold;\n}\n\n.add-dp {\n  display: flex;\n  width: 16%;\n  background-color: #79c42b;\n  text-align: center;\n  color: #fff;\n  gap: 1%;\n  font-size: medium;\n  border-radius: 5px;\n  height: 60%;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.add-dp:hover {\n  background-color: #68a822; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.add-dp:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.add-dp:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.add-new {\n  padding: 2% 0 0 0;\n  text-align: center;\n  margin-bottom: 10%;\n  border-radius: 8px;\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out, background-color 0.3s ease,\n    box-shadow 0.3s ease;\n  color: #949494;\n  background-color: #f2f2f2;\n  border: 2px dashed #000;\n  cursor: pointer;\n}\n\n.add-new:hover {\n  background-color: #e0e0e0; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.add-new:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.add-new:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.add-dp span {\n  display: flex;\n  margin: 6%;\n}\n\n.add-icon {\n  font-size: xx-large;\n}\n\n/* Department List */\n.department-section {\n  margin-bottom: 5%;\n}\n\n.department-list {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(4, minmax(20%, 1fr));\n  gap: 2%;\n  padding: 2%;\n}\n\n.department-card {\n  display: flex;\n  background: #00a1da;\n  color: #fff;\n  padding: 5%;\n  margin-bottom: 10%;\n  border-radius: 8px;\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out;\n}\n\n.department-card:hover {\n  transform: scale(1.05);\n}\n\n.department-icon {\n  width: 32px;\n  height: 32px;\n  margin: 4% 0 0 5%;\n}\n\n.dp-name {\n  font-size: x-large;\n  text-align: center;\n  margin: 5%;\n}\n\n.dp-icon {\n  font-size: x-large;\n}\n\n.add-new:hover {\n  background-color: #e0e0e0;\n}\n\n.addDp-name {\n  font-size: x-large;\n}\n\n/* 🔹 Pop-up Overlay */\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* 🔹 Pop-up Content */\n.popup-content {\n  background: #e8e9ea;\n  width: 30%;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  position: relative;\n}\n\n.popup-header {\n  display: flex;\n  justify-content: space-between;\n  background-color: #00468c;\n  color: #fff;\n  padding: 1% 4%;\n  text-align: left;\n  align-items: center;\n}\n\n.dp-form {\n  padding: 5%;\n}\n\n/* 🔹 Close Button */\n.close-popup {\n  background: none;\n  border: none;\n  font-size: x-large;\n  cursor: pointer;\n}\n\n.custom-file-button {\n  position: absolute;\n  right: 2%; /* Adjusted to the right */\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  background-color: #79c42b;\n  color: white;\n  padding: 2% 3% 0 3%;\n  border-radius: 5px;\n  font-size: small;\n  font-weight: bold;\n  border: none;\n  height: 50%;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.custom-file-button:hover {\n  background-color: #68a822; /* slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.custom-file-button:active {\n  transform: translateY(-50%) scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.custom-file-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n/* 🔹 Add Button */\n.add-button {\n  background: #79c42b;\n  color: white;\n  padding: 2% 4%;\n  border: 1px solid #79c42b;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-left: 10%;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.add-button:hover {\n  background: #68a822; /* slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.add-button:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.add-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n/* DP Cancel Button */\n.dp-cancel {\n  color: #000;\n  padding: 2% 4%;\n  cursor: pointer;\n  border-radius: 5px;\n  border: 1px solid #79c42b;\n  background-color: #fff;\n  margin-left: 50%;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.dp-cancel:hover {\n  background-color: #f2f2f2;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.dp-cancel:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.dp-cancel:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.file-upload {\n  margin-bottom: 10%;\n}\n\n.file-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 2%;\n}\n\n.file-name-input {\n  width: 100%;\n  height: 30px;\n  padding: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: medium;\n  background-color: #f8f9fa;\n  padding-right: 100px; /* Space for the button */\n}\n\n.input-group {\n  gap: 2%;\n  width: 100%;\n  margin-bottom: 5%;\n}\n\n.ad-label {\n  display: flex;\n  text-align: left;\n  margin: 2%;\n}\n\n.name-input {\n  width: 95%;\n  padding: 2%;\n}\n\n.size {\n  font-style: italic;\n  color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
